// Module
var code = "<div class=\"alignc pie-chart\"> <svg ref=\"svgElement\" role=\"graphics-document document\" width=\"100%\" :height=\"height\"></svg> </div> ";
// Exports
export default code;